<template>
    <div class="table-action-group" :class="{ 'table-action-group--wrap': wrap }" :style="groupStyle">
        <slot />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        gap?: string;
        wrap?: boolean;
    }>(),
    {
        gap: '4px',
        wrap: false,
    },
);

const groupStyle = computed<Record<string, string>>(() => ({
    '--table-action-group-gap': props.gap,
    justifyContent: 'end',
}));
</script>

<style scoped lang="scss">
.table-action-group {
    display: inline-flex;
    width: max-content;
    gap: var(--table-action-group-gap);
    align-items: center;
    white-space: nowrap;

    &--wrap {
        flex-wrap: wrap;
    }
}
</style>
